import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getSizeInPixel from './getSizeInPixel';

var getPositionFromString = function getPositionFromString(positionString, width, height, maxWidth, maxHeight, opts) {
  // eslint-disable-next-line no-unused-vars
  var options = _objectSpread({}, opts);

  var positionArray = positionString.split(' ');
  var firstPositionParts = positionArray[0].split(':');
  var secondPositionParts = (positionArray[1] || positionArray[0]).split(':');
  var firstPosition = firstPositionParts[0];
  var secondPosition = secondPositionParts[0];
  var firstPositionValue = firstPositionParts[1] || null;
  var secondPositionValue = secondPositionParts[1] || null;
  var horizontalFirst = firstPosition === 'left' || firstPosition === 'right' || secondPosition === 'top' || secondPosition === 'bottom' || firstPosition === 'center' && secondPosition === 'center';
  var horizontal = horizontalFirst ? firstPosition : secondPosition;
  var vertical = horizontalFirst ? secondPosition : firstPosition;
  var horizontalOffset = getSizeInPixel(horizontalFirst ? firstPositionValue || 0 : secondPositionValue || 0, maxWidth);
  var verticalOffset = getSizeInPixel(horizontalFirst ? secondPositionValue || 0 : firstPositionValue || 0, maxHeight);
  var position = {
    x: 0,
    y: 0,
    horizontal: horizontal,
    vertical: vertical
  };
  var style = {
    position: 'absolute',
    top: 'auto',
    bottom: 'auto',
    left: 'auto',
    right: 'auto'
  };

  if (horizontal === 'center') {
    position.x = (maxWidth - width) / 2;
    style.left = (maxWidth - width) / 2;
  } else if (horizontal === 'right') {
    position.x = maxWidth - width;
    style.right = 0;
  } else {
    style.left = 0;
  }

  if (horizontal === 'right') {
    position.x -= horizontalOffset;
    style.right += horizontalOffset;
  } else {
    position.x += horizontalOffset;
    style.left += horizontalOffset;
  }

  if (vertical === 'center') {
    position.y = (maxHeight - height) / 2;
    style.top = (maxHeight - height) / 2;
  } else if (vertical === 'bottom') {
    position.y = maxHeight - height;
    style.bottom = 0;
  } else {
    style.top = 0;
  }

  if (vertical === 'bottom') {
    position.y -= verticalOffset;
    style.bottom += verticalOffset;
  } else {
    position.y += verticalOffset;
    style.top += verticalOffset;
  }

  position.style = style;
  return position;
};

export default getPositionFromString;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/size/es/getPositionFromString.js
// module id = null
// module chunks = 